<template>
    <div class="legal-page">
        <h1>隐私政策</h1>
        <p><strong>最后更新日期：【2026】年【3】月【14】日</strong></p>

        <p>欢迎访问【LiAng】（以下简称“本网站”、“我们”）。我们非常重视您的隐私保护。本隐私政策旨在向您说明，当您访问本网站时，我们如何收集、使用、存储和披露您的个人信息。</p>

        <h2>1. 我们收集的信息</h2>
        <p>我们可能收集以下几类信息：</p>
        <ul>
            <li><strong>您主动提供的信息：</strong>当您通过本网站的联系表单联系我们、订阅资讯或使用其他互动功能时，我们可能会收集您的姓名、电子邮件地址等信息。</li>
            <li><strong>自动收集的信息：</strong>当您访问本网站时，我们的服务器可能会自动记录您的浏览器发送的信息，包括但不限于您的IP地址、浏览器类型和语言、访问时间、引荐来源网址、以及您访问的页面。
            </li>
            <li><strong>Cookie和追踪技术：</strong>我们使用Cookie和类似追踪技术来收集信息，以改善您的浏览体验，分析网站流量，并了解用户行为。关于我们如何使用Cookie，请参阅我们的<a
                    href="/cookie-policy.html">Cookie政策</a>。</li>
        </ul>

        <h2>2. 我们如何使用您的信息</h2>
        <p>我们可能将收集的信息用于以下目的：</p>
        <ul>
            <li>运营和维护本网站；</li>
            <li>回复您的咨询和请求；</li>
            <li>分析网站使用情况，以便我们改进网站内容和功能；</li>
            <li>检测、预防和解决技术问题或潜在的法律问题；</li>
            <li>向您发送我们认为您可能感兴趣的资讯（如果您已同意接收此类信息）。</li>
        </ul>

        <h2>3. 信息的披露</h2>
        <p>我们承诺不会出售、交易或向第三方出租您的个人信息，但以下情况除外：</p>
        <ul>
            <li><strong>服务提供商：</strong>我们可能聘请可信赖的第三方公司或个人协助我们运营网站、分析数据（例如Google
                Analytics），这些第三方仅在代表我们执行任务时才有权访问您的信息，并有义务对此类信息保密[citation:4]。</li>
            <li><strong>法律要求：</strong>当我们有充分理由相信，为遵守法律程序、法院命令或法律义务，或为保护我们、我们的用户或公众的权利、财产或安全所必需时，我们可能会披露您的信息[citation:8]。
            </li>
        </ul>

        <h2>4. 第三方链接</h2>
        <p>本网站可能包含指向其他外部网站的链接。请注意，我们对这些外部网站的隐私做法不承担任何责任。我们鼓励您在离开本网站时注意阅读您访问的任何其他网站的隐私声明[citation:8]。</p>

        <h2>5. 数据安全</h2>
        <p>我们采取合理的安全措施来保护您的个人信息，防止其遭到未经授权的访问、使用或披露。然而，请注意，没有任何一种互联网传输或电子存储方法是100%安全的。</p>

        <h2>6. 您的权利</h2>
        <p>根据适用的法律法规，您可能有权访问、更正或删除我们持有的关于您的个人信息。如果您希望行使这些权利，请通过下方的联系方式与我们联系。</p>

        <h2>7. 儿童隐私</h2>
        <p>本网站不面向13岁以下的儿童。我们不会故意收集13岁以下儿童的个人信息。如果您认为我们错误地收集了此类信息，请立即联系我们。</p>

        <h2>8. 本政策的变更</h2>
        <p>我们可能会不时更新本隐私政策。任何变更将在本页面上发布，并附上更新的“最后更新日期”。建议您定期查看本政策以了解最新信息。</p>

        <h2>9. 联系我们</h2>
        <p>如果您对本隐私政策有任何疑问，请通过以下方式联系我们：</p>
        <p>电子邮件：【1051966401@qq.com】</p>
        <p>或通过本网站的【联系页面/表单】。</p>
    </div>
</template>